
import Airdrop from "../../../assets/duotone/Airdrop.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AirdropIcon({ className, dataTestid = "AirdropIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Airdrop data-testid={dataTestid} className={classes} {...rest} />
  );
}
